/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import Message, { IMessage } from './../../message';
import { IDescriptorBody } from '../../descriptor';

export interface IRevisionHistoryUpdateRevisionsResponse extends IMessage {
	requestId: number;
}

export default class RevisionHistoryUpdateRevisionsResponse extends Message {
	public static readonly DESCRIPTOR_NAME: string = 'RevisionHistoryUpdateRevisionsResponse';

	public static readonly DESCRIPTOR: IDescriptorBody = {
		fields: {
			requestId: {
				type: 'uint32',
				id: 1
			}
		}
	};

	public constructor( public readonly requestId: number ) {
		super();
	}

	public toJSON(): IRevisionHistoryUpdateRevisionsResponse {
		return {
			requestId: this.requestId
		};
	}

	public static fromJSON( json: IRevisionHistoryUpdateRevisionsResponse ): RevisionHistoryUpdateRevisionsResponse {
		return new RevisionHistoryUpdateRevisionsResponse(
			json.requestId
		);
	}
}
